import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { ListComponent } from '@app/common/templates/list/list.component';
import { Module } from '@app/models/permission';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import { ExportService } from '@app/services/export.service';
import { SettingsService } from '@app/services/settings.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/list/list.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/list/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblFahrzeugAbwicklungAbschnittListComponent extends ListComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public changeDetectorRef: ChangeDetectorRef,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public elRef: ElementRef,
		public exportService: ExportService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public settingsService: SettingsService,
		public translate: TranslateService,
		public dialogService: DialogService,
	) {
		super(accountService, breadcrumbService, changeDetectorRef, confirmationService, crudService, elRef, exportService, globals, messageService, router, settingsService, translate, dialogService);

		this.apiUrl = 'TblFahrzeugAbwicklungAbschnitt';
		this.name = 'MENU.FAHRZEUG_ABWICKLUNG_ABSCHNITT';
		this.url = '/' + PATH.FAHRZEUG_ABWICKLUNG_ABSCHNITT;
		this.module = Module.Masterdata;

		this.possibleCols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: false, width: 400 },
			{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
			//{ type: 'date', key: 'geoeffnet_datetime', required: false, width: 400, dateonly: true },
			//{ type: 'date', key: 'geschlossen_datetime', required: false, width: 400, dateonly: true },
			{ type: 'text', key: 'geoeffnet_string_german', required: false, width: 400, dateonly: true },
			{ type: 'text', key: 'geschlossen_string_german', required: false, width: 400, dateonly: true },
			{ type: 'text', key: 'FREMD_abgezeichnet_mitarbeiter_ankey', required: false, width: 400 },
			{ type: 'text', key: 'FREMD_abgezeichnet_mitarbeiter_bezeichnung', required: false, width: 400 },
			{ type: 'text', key: 'FREMD_abschnitt_typ_ankey', required: false, width: 400 },
			{ type: 'text', key: 'FREMD_abschnitt_typ_bezeichnung', required: false, width: 400 },
			{ type: 'text', key: 'bemerkungen', required: false, width: 400 },
		];
		this.cols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
			{ type: 'text', key: 'geoeffnet_string_german', required: false, width: 400, dateonly: true },
			{ type: 'text', key: 'geschlossen_string_german', required: false, width: 400, dateonly: true },
			{ type: 'text', key: 'FREMD_abgezeichnet_mitarbeiter_bezeichnung', required: false, width: 400 },
			{ type: 'text', key: 'FREMD_abschnitt_typ_bezeichnung', required: false, width: 400 },
		];

		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.LIST', routerLink: [this.url + '/' + PATH.LIST] }
		]);
	}
}
